import React, { ActivityItem, IActivityItemProps, Icon, Spinner, TextField, Toggle } from '@fluentui/react';
import moment from 'moment-timezone';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HealAPI } from '../../healApi';
import { toast } from '../../redux/message/actions';
import { VisitLogEntry } from '../../redux/visits/types';

interface Props {
  visitCode: string;
  updatedAt: string;
}

export function VisitLog({ visitCode, updatedAt }: Props): ReactElement {
  const [fetching, setFetching] = useState(false);
  const [logs, setLogs] = useState<VisitLogEntry[]>([]);
  const [currentLog, setCurrentLog] = useState('');
  const [showSystemLogs, setShowSystemLogs] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    setFetching(true);
    HealAPI.fetchVisitLogs(visitCode).then((response) => {
      setLogs(response.data?.results || []);
      setFetching(false);
    });
  }, [visitCode, updatedAt]);

  const insertLog = () => {
    if (currentLog.length === 0) {
      return;
    }

    setFetching(true);
    HealAPI.insertLog(visitCode, currentLog).then((response) => {
      if (response.ok) {
        const data = logs.slice();
        data.unshift(response.data!);
        setLogs(data);
        setFetching(false);
        setCurrentLog('');
        dispatch(
          toast({
            type: 'success',
            title: 'Success',
            content: 'Log entry has been successfully added',
          })
        );
      }
    });
  };

  const onLogKeyPress = (e: any) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      insertLog();
    }
  };

  return (
    <div>
      <TextField multiline={true} disabled={fetching} rows={3} placeholder="Add log entry" onKeyPress={onLogKeyPress} onChange={(ev, v) => setCurrentLog(v!)} value={currentLog} />
      <div className="flex justify-end">
        <Toggle inlineLabel label="View System Messages" checked={showSystemLogs} onChange={(e, checked) => setShowSystemLogs(!!checked)} />
      </div>
      {fetching && <Spinner style={{ marginBottom: 10 }} />}
      {logs
        .filter((l) => showSystemLogs || (l.userAccountFullName !== 'System Automated' && l.userAccountFullName !== 'System Heal'))
        .map((log, index) => {
          const props: IActivityItemProps = {
            activityDescription: [
              <span key={1} style={{ color: '#333' }}>
                {log.log}
              </span>,
              <span key={2}>&nbsp;{log.userAccountFullName}</span>,
            ],
            activityIcon: <Icon iconName={'Message'} />,
            timeStamp: moment(log.createdAt).tz(moment.tz.guess()).format('h:mm:ss A z - M/D/YYYY'),
          };
          return <ActivityItem {...props} key={index} />;
        })}
    </div>
  );
}
